<template>
  <span class="checkbox" :class="{ checked: value || half, half: propToBool(half) }" @click="$emit('input', !value)" />
</template>

<script>
import { propToBool } from '../../../../libraries/common'
export default {
  props: ['value', 'half'],
  methods: {
    propToBool,
  },
}
</script>

<style lang="scss" scoped>
.checkbox {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 18px;
  min-width: 17px;
  height: 18px;
  border: 2px solid #5e5e5e;
  box-shadow: 0 0 1px 1px rgba(22, 23, 26, 0.08), 0 1px 4px 0 rgba(22, 23, 26, 0.2);

  &.checked {
    background-color: #5e5e5e;
    &:not(.half):after {
      content: '';
      left: 9px;
      top: 5px;
      width: 5px;
      height: 10px;
      border: solid white;
      border-width: 0 3px 3px 0;
      transform: rotate(45deg);
    }

    &.half {
      &:after {
        content: '';
        left: 9px;
        top: 5px;
        width: 8px;
        height: 4px;
        border: solid white;
        border-width: 2px 0 2px;
      }
    }
  }
}
</style>